import { Image, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ICardProps {
  title: string;
  picSrc: string;
  onClick?(): void;
}

export const Card: React.VFC<ICardProps> = ({ title, picSrc, onClick }) => {
  return (
    <div className={styles['card']} data-name="about_report_card">
      <UIHeading2 textAlign="center">{title}</UIHeading2>
      <div className={styles['image']}>
        <Image src={picSrc} width="100%" alt="" onClick={onClick} />
      </div>
    </div>
  );
};
